import { defaultFilters } from './taskFilters.js'
import { dayNumber } from './plannerSchedule.js'
const arrays = ['plans', 'buckets', 'labels', 'assignees']
const choices = { status: ['all','pending','active','completed'], group: ['status','plan','bucket','label','person','priority'], deadline: ['all','none','overdue','today','next7','range'], priority: ['all','urgent','important','medium','low'], sort: ['source','deadline','priority','title'] }
export function readPlannerLocation(search, saved = {}) {
  const p = new URLSearchParams(search)
  const filters = { ...defaultFilters, ...(p.has('filters') ? {} : saved) }
  if (p.has('filters')) {
    for (const key of arrays) filters[key] = [...new Set(p.getAll(key))].filter(value => value.length <= 200).slice(0, 500)
    filters.search = (p.get('search') || '').slice(0, 500)
    filters.mine = p.get('mine') === '1'
    filters.hide_completed = p.get('hide_completed') === '1'
    for (const [key, values] of Object.entries(choices)) if (values.includes(p.get(key))) filters[key] = p.get(key)
    for (const key of ['due_from','due_to']) filters[key] = dayNumber(p.get(key)) !== null ? p.get(key) : ''
  }
  return { view_id: p.get('view_id') || '', filters, display: ['board','list','calendar','timeline'].includes(p.get('display')) ? p.get('display') : 'board', calendar: p.get('calendar') === 'month' ? 'month' : 'week', date: dayNumber(p.get('date')) !== null ? p.get('date') : '', task_id: /^[A-Za-z0-9_-]{1,100}$/.test(p.get('task_id') || '') ? p.get('task_id') : '', section: p.get('section') === 'settings' ? 'settings' : 'views' }
}
export function writePlannerLocation(search, state) {
  const p = new URLSearchParams(search)
  for (const key of ['view_id','display','calendar','date','task_id','section', 'filters', ...Object.keys(defaultFilters)]) p.delete(key)
  for (const key of ['view_id','display','calendar','date','task_id','section']) if (state[key]) p.set(key, state[key])
  p.set('filters', '1')
  for (const [key, value] of Object.entries(state.filters)) {
    if (arrays.includes(key)) value.forEach(item => p.append(key, item))
    else if (key === 'mine' || key === 'hide_completed') { if (value) p.set(key,'1') }
    else if (value !== '' && value !== defaultFilters[key]) p.set(key, value)
  }
  return `?${p.toString()}`
}

export function restorableTeamsSearch(current, remembered, visibleViewIds) {
  if (new URLSearchParams(current).has('filters') || !remembered) return null
  const saved = new URLSearchParams(remembered)
  return saved.has('filters') && visibleViewIds.includes(saved.get('view_id')) ? remembered : null
}

export function filtersChanged(current, saved = {}) {
  const normalize = filters => JSON.stringify(Object.keys(defaultFilters).map(key => { const value = { ...defaultFilters, ...filters }[key]; return Array.isArray(value) ? [...value].sort() : value }))
  return normalize(current) !== normalize(saved)
}
